const EquipmentActivity = {
  dispatch_return: 'dispatch_return',
  stuffing_emptying: 'stuffing_emptying',
  transport: 'transport',
} as const

export type EquipmentActivityType = typeof EquipmentActivity[keyof typeof EquipmentActivity]

export default EquipmentActivity
